import SpecialSale from 'src/dispensary/specials/sale';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialSale, MainDispensaryLayout);
